import React, {useState, useEffect, createContext} from "react";
import axios from "./axios";

const UserContext = createContext([{}, () => {}]);
const DATE_FORMAT_SERVER = "DD/MM/YYYY";
const USA_DATE_FORMAT_SERVER = "MM/DD/YYYY";
const TIME_FORMAT_SERVER = "HH:mm";
const DATE_TIME_FORMAT_SERVER = DATE_FORMAT_SERVER + " " + TIME_FORMAT_SERVER;
const USA_DATE_TIME_FORMAT_SERVER = USA_DATE_FORMAT_SERVER + " " + TIME_FORMAT_SERVER;

const UserProvider = props => {
    const {children} = props;
    const [user, setUser] = useState();
    const [userLoading, setUserLoading] = useState(false);
    const [menuPosition, setMenuPosition] = useState(() => {
        const storedState = localStorage.getItem('menuClosed');
        return storedState ? JSON.parse(storedState) : {leftMenuClosed: false, rightMenuClosed: false};
    });
    const [isOpenPinnedMenu, setOpenPinnedMenu] = useState(false);

    useEffect(() => {
        localStorage.setItem('menuClosed', JSON.stringify(menuPosition));
    }, [menuPosition]);

    useEffect(() => {
        setOpenPinnedMenu(user && user.testResultId != undefined);
        if(user != undefined) {
            setDateFormats(user);
        }
    }, [user]);

    const updateUser = newUser => {
        setUser(Object.assign({}, user, {
            ...newUser
        }));
    }

    const loadUser = () => {
        setUserLoading(true);
        axios.get('/web/ui/session/public/userSession')
            .then(response => {
                setUser(response.data);
                setUserLoading(false);
            });
    }

    const setDateFormats = (updateUser) => {
        if(updateUser == undefined) {
            return;
        }
        const userLocale = (updateUser.locale ? updateUser.locale : 'en_AU').replace('_', '-');
        updateUser.dateFormat =  new Intl.DateTimeFormat(userLocale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: updateUser.timeZone
        });

        updateUser.dateTimeFormat = new Intl.DateTimeFormat(userLocale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: "2-digit",
            second: '2-digit',
            timeZone: updateUser.timeZone
        });

        updateUser.dateTimeMinuteFormat = new Intl.DateTimeFormat(userLocale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            timeZone: updateUser.timeZone
        });

        updateUser.timeFormat = new Intl.DateTimeFormat(userLocale, {
            hour: 'numeric',
            minute: "2-digit",
            timeZone: updateUser.timeZone
        });

        updateUser.dateTimeFormat24hr = new Intl.DateTimeFormat(userLocale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: "2-digit",
            second: '2-digit',
            timeZone: updateUser.timeZone,
            hour12: false
        });

        updateUser.getDateFormatString = ()=>{
            if(userLocale === 'en-US'){
                return USA_DATE_FORMAT_SERVER;
            }
            return DATE_FORMAT_SERVER;
        };

        updateUser.getDateTimeFormatString = ()=>{
            if(userLocale === 'en-US'){
                return USA_DATE_TIME_FORMAT_SERVER;
            }
            return DATE_TIME_FORMAT_SERVER;
        };
    }

    const toggleContextMenuRight = () => {
        setMenuPosition((currentMenuPosition) => ({...currentMenuPosition, rightMenuClosed: !currentMenuPosition.rightMenuClosed}))
    }

    const updateLeftMenuClosed = (closed) => {
        setMenuPosition((currentMenuPosition) => ({...currentMenuPosition, leftMenuClosed: closed}))
    }

    const updateRightMenuClosed = (closed) => {
        setMenuPosition((currentMenuPosition) => ({...currentMenuPosition, rightMenuClosed: closed}))
    }

    const updateClass = (classId) => {
        setUserLoading(true);
        axios.get('/web/ui/session/updateCurrentClass', {params: {classId: classId}})
            .then(response => {
                if (response.data !== undefined) {
                    user.classId = response.data.classId;
                    updateUser(user);
                }
                setUserLoading(false);
            });
    }

    const changeCmsMode =  async (cmsMode) => {
        if(cmsMode == undefined || user.subscriberType !== 'ADMINISTRATOR') {
            return;
        }
        setUserLoading(true);
        await axios.get('/web/ui/session/changeCmsMode', {params: {cmsMode: cmsMode}})
            .then(response => {
                updateUser(response.data);
                setUserLoading(false);
            });
    }

    function updateFollowUpWork(testResultId) {
        axios.post('/web/ui/test/updateCurrentTestResult', null, {params: {testResultId: testResultId}})
            .then(response => {
                if(testResultId == undefined) {
                    setOpenPinnedMenu(false);
                } else {
                    setOpenPinnedMenu(true);
                }
                setUser(response.data);
            }).catch((error) => {
                console.error('Error updating test result', error);
            });
    }

    useEffect(() => {
        loadUser();
    }, []);

    useEffect(() => {
        if(menuPosition.rightMenuClosed) {
            $('.js-content-body').removeClass('h-nav-r-open').addClass('ch-nav-r-closed');
        } else {
            $('.js-content-body').removeClass('ch-nav-r-closed').addClass('ch-nav-r-open');
        }
    }, [menuPosition]);


    if (globalReactFunctions !== undefined) {
        globalReactFunctions.loadUser = loadUser;
    }

    const contextValue =  {
        user: user,
        updateUser: updateUser,
        setUser: setUser,
        updateFollowUpWork: updateFollowUpWork,
        loadUser: loadUser,
        toggleContextMenuRight: toggleContextMenuRight,
        updateLeftMenuClosed: updateLeftMenuClosed,
        updateRightMenuClosed: updateRightMenuClosed,
        menuPosition: menuPosition,
        setOpenPinnedMenu: setOpenPinnedMenu,
        isOpenPinnedMenu: isOpenPinnedMenu,
        updateClass: updateClass,
        userLoading: userLoading,
        changeCmsMode: changeCmsMode
    }

    return (
        <UserContext.Provider value={contextValue}>
            {children}
        </UserContext.Provider>
    );
}

export {UserContext, UserProvider};
